import _omit from "lodash/omit";

export const BANDEIRAS_CARTAO = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  elo: 'Elo',
  amex: 'American Express',
  hipercard: 'Hipercard',
  dinersclub: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
};

export const TEXTO_NENHUMA_RECONHECIDA = 'Nenhuma reconhecida';

function textoBruto(valor) {
  return (Array.isArray(valor) ? valor.join(',') : (valor || '')).trim();
}

export function listarBandeiras(valor) {
  return textoBruto(valor)
    .split(',')
    .map((bandeira) => bandeira.trim().toLowerCase())
    .filter((bandeira) => BANDEIRAS_CARTAO[bandeira])
    .filter((bandeira, indice, lista) => lista.indexOf(bandeira) === indice);
}

export function nomesBandeiras(bandeiras) {
  return bandeiras.map((bandeira) => BANDEIRAS_CARTAO[bandeira] || bandeira).join(', ');
}

export function cobrancaParaEdicao(cobranca) {
  const bandeiras = listarBandeiras(cobranca.bandeiras_cartao);
  const bandeirasErp = listarBandeiras(cobranca.bandeiras_cartao_erp);
  const erpBruto = textoBruto(cobranca.bandeiras_cartao_erp);
  const erpSemReconhecidas = erpBruto !== '' && bandeirasErp.length === 0;

  return {
    ...cobranca,
    bandeiras_cartao: bandeiras,
    bandeiras_cartao_erp: nomesBandeiras(bandeirasErp) || erpBruto || '-',
    bandeiras_efetivas: nomesBandeiras(bandeiras.length ? bandeiras : bandeirasErp),
    bandeiras_nao_reconhecidas: bandeiras.length === 0 && erpSemReconhecidas,
  };
}

export function textoBandeirasDaListagem(row) {
  if (row.cartao != 1) return '-';

  if (row.bandeiras_nao_reconhecidas) return TEXTO_NENHUMA_RECONHECIDA;

  return row.bandeiras_efetivas || 'Todas';
}

export function cobrancaParaSalvar(cobranca) {
  return {
    ..._omit(cobranca, ['bandeiras_cartao_erp', 'bandeiras_efetivas', 'bandeiras_nao_reconhecidas']),
    bandeiras_cartao: listarBandeiras(cobranca.bandeiras_cartao),
  };
}
